import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Load locale files
let en, fr, sw

try {
  en = require('./locales/en.json')
} catch (error) {
  console.warn('Failed to load English locale:', error.message)
  en = {}
}

try {
  fr = require('./locales/fr.json')
} catch (error) {
  console.warn('Failed to load French locale:', error.message)
  fr = {}
}

try {
  sw = require('./locales/sw.json')
} catch (error) {
  console.warn('Failed to load Swahili locale:', error.message)
  sw = {}
}

// Detect user's preferred language
const getDefaultLocale = () => {
  // Check localStorage first
  const savedLocale = localStorage.getItem('estamp-locale')
  if (savedLocale && ['en', 'fr'].includes(savedLocale)) {
    return savedLocale
  }
  
  // If saved locale is not supported (e.g., 'sw'), remove it and default to English
  if (savedLocale && !['en', 'fr'].includes(savedLocale)) {
    localStorage.removeItem('estamp-locale')
  }
  
  // Check browser language
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.startsWith('fr')) return 'fr'
  
  // Default to English
  return 'en'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    fr
  },
  // Enable pluralization
  pluralizationRules: {
    fr: function(choice, choicesLength) {
      return choice > 1 ? 1 : 0
    }
  },
  // Date/time formatting
  dateTimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    fr: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  },
  // Number formatting
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD'
      },
      decimal: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    },
    fr: {
      currency: {
        style: 'currency',
        currency: 'CDF'
      },
      decimal: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  }
})

// Make i18n instance available globally for the store to access
if (typeof window !== 'undefined') {
  window.$i18n = i18n
}

// Setup DevExtreme locales with error handling
try {
  const { setupDevExtremeLocales } = require('./plugins/devExtreme')
  setupDevExtremeLocales(i18n)
} catch (error) {
  console.warn('DevExtreme localization setup failed:', error.message)
  // Fallback: basic DevExtreme configuration
  if (window.DevExpress) {
    window.DevExpress.config({
      defaultLocale: i18n.locale
    })
  }
}

// Setup Moment.js locales with error handling
try {
  const { setupMomentLocales } = require('./plugins/moment')
  setupMomentLocales(i18n)
} catch (error) {
  console.warn('Moment.js localization setup failed:', error.message)
}

export default i18n